/**
 * @preserve [route] gmap/googles route functionalty | Copyright 2025 digiconcept
 */

import { error } from 'gmap'

/**
 *
 * @param {!Object} route
 * @returns {google.maps.DirectionsRequest}
 */
function routeOptsToDirectionsRequest (route) {
  // TODO: handle lnglat
  return {
    origin: route.start,
    destination: route.stop,
    region: route.region || 'AT',
    travelMode: (route.travelmode && google.maps.TravelMode[route.travelmode]) || google.maps.TravelMode.DRIVING
  }
}

let directionsService, bounds

function isRequested (dcopts) {
  return dcopts.route && dcopts.route.start && dcopts.route.stop
}

function create (map, dcopts) {
  const route = dcopts.route

  directionsService = directionsService || new google.maps.DirectionsService()

  const renderOpts = {}
  const icon = route.icon || (dcopts.icons && dcopts.icons.markers && dcopts.icons.markers[0]) || null
  if (icon) {
    renderOpts.markerOptions = {
      icon
    }
  }
  const directionsDisplay = new google.maps.DirectionsRenderer(renderOpts)
  directionsDisplay.setMap(map)

  directionsService.route(routeOptsToDirectionsRequest(dcopts.route), function (response, status) {
    if (status === google.maps.DirectionsStatus.OK) {
      directionsDisplay.setDirections(response)
      bounds = response.routes[0].bounds
    } else {
      error('Directions request failed due to ' + status)
    }
  })

  // return cleaner
  return {
    getBounds: function () {
      return bounds
    }
  }
}

export default {
  isRequested,
  create
}
